/**
 * @file
 * Scripts for location filter multicheckbox.
 */

const $context = $(
  '#views-exposed-form-locations-content-locations-map .form-composite',
  context
);

$context.once('locations-multiselect').each((index, el) => {
  const $this = $(el);

  $this.find('legend').click(() => $this.toggleClass('is-open'));
});
